import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgExtern = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2816 8.14057L10.5977 4.39614L11.9713 3L18 9.12779L11.9713 15.2556L10.5977 13.8594L14.2816 10.115H12.7414C8.98647 10.115 5.94253 13.209 5.94253 17.0256V19H4V17.0256C4 12.1185 7.91365 8.14057 12.7414 8.14057H14.2816Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgExtern);

export default ForwardRef;
